import Skeleton from "react-loading-skeleton";
import { TableBody, TableCell, TableRow } from "@/components/catalyst/Table";

export function PartnersSkeleton() {
	return (
		<TableBody>
			{Array.from({ length: 5 }).map((_, i) => (
				<TableRow key={i}>
					<TableCell>
						<Skeleton width={120} />
					</TableCell>
					<TableCell>
						<Skeleton width={100} />
					</TableCell>
					<TableCell>
						<Skeleton width={60} borderRadius={9999} />
					</TableCell>
					<TableCell>
						<Skeleton width={60} borderRadius={9999} />
					</TableCell>
					<TableCell>
						<Skeleton width={20} height={20} circle />
					</TableCell>
				</TableRow>
			))}
		</TableBody>
	);
}
